import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../bins/parts/bin-profile';
import '../../bins/parts/bin-photo-button';
import '../../bins/parts/bin-location';
import '../../common/bn-property';

class WorkOrderReviewBin extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: grid;
        grid-template-columns: 75px 3fr 1fr 4fr;
        grid-gap: 1em;
      }
      bin-profile {
        max-height: 13rem;
      }
      .column {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
      }
      .column bn-property {
        width: 50%;
        min-width: auto;
        margin-bottom: .5em;
      }
      .photo bn-property, .location bn-property {
        margin: 0;
      }
      .photo bin-photo-button {
        width: 100%;
        height: calc(100% - 1em);
      }
      bin-location {
        width: 100%;
        height: calc(100% - 1em);
      }
      @media(max-width: 1000px) {
        :host {
          grid-template-columns: 75px 1fr;
          grid-template-rows: auto 14em;
        }
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }

    if (!this.entity) {
      return html``;
    }

    const topHeight = this.getProperty('dimensions.top.height');
    const topRadius = this.getProperty('dimensions.top.truncatedRadius');
    const lipHeight = this.getProperty('dimensions.lipHeight');
    const deviceDepth = this.getProperty('dimensions.deviceDepth');
    const bodyHeight = this.getProperty('dimensions.body.height');
    const bodyRadius = this.getProperty('dimensions.body.radius');
    const hopperHeight = this.getProperty('dimensions.hopper.height');
    const hopperRadius = this.getProperty('dimensions.hopper.truncatedRadius');

    return html`
      <div class="column">
        <bin-profile .href="${this.href}"></bin-profile>
      </div>
      <div class="column">
        <bn-property stacked label="Top Height">
          <bn-dimension value=${topHeight}></bn-dimension>
        </bn-property>

        <bn-property stacked label="Top Radius">
          <bn-dimension value=${topRadius}></bn-dimension>
        </bn-property>

        <bn-property stacked label="Top Angle">${this.getProperty('dimensions.top.angle')} <span class="unit">deg</span></bn-property>

        <bn-property stacked label="Lip Height">
          <bn-dimension value=${lipHeight}></bn-dimension>
        </bn-property>

        <bn-property stacked label="Device Depth">
          <bn-dimension value=${deviceDepth}></bn-dimension>
        </bn-property>

        <bn-property stacked label="Body Height">
          <bn-dimension value=${bodyHeight}></bn-dimension>
        </bn-property>

        <bn-property stacked label="Body Radius">
          <bn-dimension value=${bodyRadius}></bn-dimension>
        </bn-property>

        <bn-property stacked label="Hopper Height">
          <bn-dimension value=${hopperHeight}></bn-dimension>
        </bn-property>

        <bn-property stacked label="Hopper Radius">
          <bn-dimension value=${hopperRadius}></bn-dimension>
        </bn-property>

        <bn-property stacked label="Hopper Angle">${this.getProperty('dimensions.hopper.angle')} <span class="unit">deg</span></bn-property>
      </div>
      <div class="column photo">
        <bn-property stacked label="Photo"></bn-property>
        <bin-photo-button .href="${this.href}"></bin-photo-button>
      </div>
      <div class="column location">
        <bn-property stacked label="Location"></bn-property>
        <bin-location .href="${this.href}"></bin-location>
      </div>
    `;
  }
}

window.customElements.define('work-order-review-bin', WorkOrderReviewBin);
